import { createContext, useContext } from 'react';
export var cultureContext = /*#__PURE__*/createContext({
  culture: undefined,
  getSelectedCultureCode: function getSelectedCultureCode() {
    return undefined;
  }
});
export var useCultureContext = function useCultureContext() {
  return useContext(cultureContext);
};